import { Routes } from '@angular/router';
import { authenticationGuard } from '@auth/guards/authentication-guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/routes'),
  },
  {
    path: 'dashboard',
    canActivate: [authenticationGuard],
    loadChildren: () => import('./dashboard/routes'),
  },
  {
    path: 'administration',
    canActivate: [authenticationGuard],
    loadChildren: () => import('./administration/routes'),
  },
  {
    path: 'teaching',
    canActivate: [authenticationGuard],
    loadChildren: () => import('./teaching/routes'),
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
